export const ROUTE_CHANGED = 'ROUTE_CHANGED';

export interface RouteChangedPayload {
  title: string;
  analyticsSiteId: number;
  location: Location;
}
